/* SCROLL LENIS */
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const lenis = new Lenis({
      smooth: true,
      smoothWheel: true,
      syncTouch: false,
      syncTouchLerp: 0.1,
      duration: 1.5,
      lerp: 0.1
    })
    
    lenis.on('scroll', (e) => {
      // console.log(e)
    })
    
    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)
  }, 500); 
});
/* END SCROLL LENIS */

/* WAGON GLOBAL */
document.addEventListener('DOMContentLoaded', function () {

  /* SCROLLMAGIC */
  
    let controller = new ScrollMagic.Controller({
      refreshInterval: 0,
    });  
  
    var anim_footer_1 = TweenMax.to("footer._footer aside._one figure._bg>img", 0.5, {y: "20%", ease: Power1.easeInOut});
    var scene_footer_1 = new ScrollMagic.Scene({triggerElement: "#_trigger_footer_1", duration: "200%" })
      .setTween(anim_footer_1)
      .triggerHook(1)
      .addTo(controller);
  
  /* END SCROLLMAGIC */


  function iOSDetector() {
    return navigator.userAgent.includes("Mac");
  }

  if (iOSDetector()) {
    const footer = document.querySelector('footer._footer ._one .row ._1 ._info');
    footer.classList.add('ios');
  }
  
});
/* END WAGON GLOBAL */


/* PRELOAD */
$(window).on("load", function() {
  $('.shopify-section>main>section').addClass('_on');
});
/* END PRELOAD */


/* SCROLL */
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
     var scrollPos = 0;
    // adding scroll event
     window.addEventListener('scroll', function(){
       
      // detects new state and compares it with the previous one
       if ((document.body.getBoundingClientRect()).top > scrollPos)
         $(".superheader").addClass("up");
       else
         $(".superheader").removeClass("up");
      // saves the new position for the next iteration
       scrollPos = (document.body.getBoundingClientRect()).top;
     });

    }, 500); // 500 milliseconds = 0.5 seconds
});
/* END SCROLL */


/* CONSOLE SIGNATURE */
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    console.log("Built with ❤️ and plenty of Colombian Coffee ☕ by Wagon Studio — github.com/codevamon");
  }, 5000); // 5000 milliseconds = 5 seconds
});
/* END CONSOLE SIGNATURE */


(function () {
  // Utility: does it already have an accessible name?
  function hasName(el){
    if (!el) return false;
    if (el.getAttribute('aria-label')) return true;
    if (el.getAttribute('aria-labelledby')) return true;
    return (el.textContent || '').trim().length > 0;
  }

  // Patch an element so it behaves as an accessible button
  function ensureButton(el, label){
    if (!el || el.dataset.a11yPatched === '1') return;

    el.setAttribute('role', 'button');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    if (label && !hasName(el)) el.setAttribute('aria-label', label);

    // Keyboard support (Enter/Space)
    el.addEventListener('keydown', function(e){
      if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); el.click(); }
      if (e.key === 'Enter') { e.preventDefault(); el.click(); }
    }, { passive: false });

    el.dataset.a11yPatched = '1';
  }

  // Hide decorative icons inside (if any)
  function hideIcons(selector){
    document.querySelectorAll(selector).forEach(function(i){
      i.setAttribute('aria-hidden', 'true');
      i.setAttribute('role', 'presentation');
    });
  }

  function run(){
    // 1) Qty: minus / plus (anchors that don’t navigate)
    ensureButton(document.querySelector('a#minus'), 'Decrease quantity');
    ensureButton(document.querySelector('a#plus'),  'Increase quantity');
    hideIcons('a#minus i, a#plus i, a#minus svg, a#plus svg, a#minus img, a#plus img');

    // 2) Subscription button on PDP (dynamic ID per template)
    var subBtn = document.querySelector('div[id^="Subscription-Btn-template--"][id$="__product"]');
    ensureButton(subBtn, 'Subscribe and save');

    // 3) Review histogram row (JDGM) and its bar
    document.querySelectorAll('.jdgm-histogram_row').forEach(function(row){
      ensureButton(row, 'View reviews for this rating');
    });
    document.querySelectorAll('.jdgm-histogram__bar-content').forEach(function(bar){
      ensureButton(bar, 'View reviews for this percentage');
    });

    // 4) Payment widget/third-party (Klarna/Shop Pay) – spans acting as buttons
    document.querySelectorAll('span.needsclick[class*="kl-private-reset-css"], span[class*="kl-private-reset-css"][role="presentation"]').forEach(function(sp){
      ensureButton(sp, 'Open payment method');
    });

    // 5) Widget with obfuscated classes (example)
    ensureButton(document.querySelector('div._2ja4y42'), 'Open widget');

    // (Optional) If you have other non-native elements that act as buttons, add them here using ensureButton(...)
  }

  // Run now…
  run();

  // …and observe in case those nodes are injected later (third-party apps/JS)
  var mo = new MutationObserver(function(){
    run();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
